import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Outlet } from "react-router-dom";
import { toast } from "react-toastify";
import { RootState } from "../app/features/template/store";

type Props = {
  check: (rbac: any) => boolean;
};

const ProtectedRoute = ({ check }: Props) => {
  const navigate = useNavigate();

  const rbacDetails = useSelector(
    (state: RootState) => state.userProfile?.rbacDetails
  );
  const hasRbacLoaded = !!rbacDetails
    && Object.values(rbacDetails).some(
        (value) => typeof value === "string" && value.trim() !== ""
      );
  const hasAccess = rbacDetails ? check(rbacDetails) : false;

  useEffect(() => {
    if (!hasRbacLoaded) return;

    if (!hasAccess) {
      toast.error("Forbidden: You don’t have access");
      navigate("/app", { replace: true });
    }
  }, [hasRbacLoaded, hasAccess, navigate]);

  // UI handling AFTER hooks
  if (!hasRbacLoaded) return null;
  if (!hasAccess) return null;

  return <Outlet />;
};

export default ProtectedRoute;